import * as Yup from 'yup';

export const AiTaskValidationSchema = Yup.object().shape({
  promptTemplate: Yup.object().required('Prompt ID is required'),
  promptTemplateVersion: Yup.object().required('Version is required'),
  body: Yup.string().required('Description is required')
});
